export enum BenchmarkType {
  BestPractice = 'best_practice',
  CompanyAverage = 'company_average',
  CustomerAverage = 'customer_average',
}
